module.exports = {"name":"simplifiedView","audiences":["newAndNoTeamsAndNoBoards"],"experimentAllocation":0.1,"defaultWeight":1,"experimentVersion":"v1","autoTrack":true,"defaults":{"enabled":false},"audienceSettings":{"startDate":"2018-09-25"},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/simplifiedView.json
// module id = ySAo
// module chunks = 1